module.exports = __webpack_public_path__ + "img/in1.ed1846e6.png";